import { render, staticRenderFns } from "./DiagnosticConfigurationModal.vue?vue&type=template&id=5c0f5786&scoped=true&"
import script from "./DiagnosticConfigurationModal.vue?vue&type=script&lang=js&"
export * from "./DiagnosticConfigurationModal.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticConfigurationModal.vue?vue&type=style&index=0&id=5c0f5786&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0f5786",
  null
  
)

export default component.exports